<template>
	<div class="row voffset4">

		<div class="col-sm-4">
			<button  v-if="previousDisabled && !opignoMode" type="button" class="btn btn-sm btn-primary btn-rounded"
			@click="previous()"><i class="fa fa-chevron-left" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;{{ previousLabel }}</button>
		</div>


		<div class="col-sm-4 pull-right text-right">
			<button v-if="clotureTourEnabled" class="btn btn-warning btn-rounded"@click="toggleUntoggle()">Je n'ai plus de patient(e)</button>
		</div>

		<div class="col-sm-4 pull-right">
			<button :disabled="nextButtonDisabled" type="button" class="btn btn-sm btn-primary btn-rounded" @click="next()">{{ nextLabel }}&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-chevron-right" aria-hidden="true"></i></button>
			<div v-if="answerMissing" style="color:red">Veuillez sélectionner une réponse avant de passer au {{ currentStep != 'SATISFACTION_SURVEY' ? "critère suivant" : "question suivante" }}.</div>
		</div>

		<modal effect="fade" title="Attention !" :value="showModal" :cancel-text="cancelTextModal" :ok-text="okTextModal" @ok="finishStep()" @cancel="toggleUntoggle()">
			<div class="text-center" v-html="finishStepModalText">
			</div>
		</modal>
	</div>

</template>

<script>
	import {modal as Modal} from 'vue-strap'

	export default {
		components: {
			Modal
		},
		computed: {
	        opignoMode: function()  {
	            return this.$store.state.opignoMode;
	        },
			answerMissing: function()	{
				return this.$store.state.user.answerMissing;
			},
			nextButtonDisabled: function()	{
				return this.$store.state.user.nextButtonDisabled;
			},
			currentStep: function()	{
				return this.$store.state.user.currentStep;
			},
			currentPatient: function()	{
				return this.$store.state.user.currentPatient;
			},
			currentPosition: function()	{
				return this.$store.state.user.currentPosition;
			},
			nbPatients: function()	{
				return this.$store.state.user.nbPatients;
			},
			nbPatientsFilled: function()	{
				return this.$store.getters.nbPatientsFilled;
			},
			criteriaQuestionTotalNumber: function()	{
				return this.$store.getters.criteriaQuestionTotalNumber;
			},
			previousDisabled: function() {
				return !(this.currentStep != "CRITIC_STEP" && (this.currentPatient == 1 || this.currentPatient == 0) && this.currentPosition == 1);
			},
			previousLabel: function()	{
				if (this.currentStep != 'FIRST_STEP' && this.currentPosition == 1 && this.currentPatient <= 1)	{
					return 'Etape précédente';
				}
				if (this.currentStep != 'SATISFACTION_SURVEY')	{
					if (this.currentPosition == 1 && this.currentPatient != 1 && this.currentStep != 'CRITIC_STEP')
						return 'Patient précédent';
					if (this.currentPosition != 1 || this.currentPatient != 1)	{
						return 'Critère précédent';
					}
				}
				return "Question précédente";
			},
			nextLabel: function()	{
				if (this.currentStep != 'SATISFACTION_SURVEY' && this.currentStep != 'CRITIC_STEP')	{
					if (this.currentPosition == this.criteriaQuestionTotalNumber && this.currentPatient != this.nbPatients)
						return 'Patient suivant';
					if (this.currentPosition != this.criteriaQuestionTotalNumber || this.currentPatient != this.nbPatients)	{
						return 'Critère suivant';
					}
				}
				if (this.currentPosition == this.criteriaQuestionTotalNumber)	{
					return "Finir";
				}
				return "Question suivante";
			},
			finishStepModalText: function()	{
				if (this.isFirstOrSecondStep)	{
					return (this.nbPatientsFilled < this.nbPatients ? "Vous avez rempli moins de " + this.nbPatients + " dossiers patients.<br>" : "") + "Souhaitez-vous clôturer le tour maintenant ?";
				}
				return "";
			},
			clotureTourEnabled: function() {
				if (this.isFirstOrSecondStep) {
					if ((this.nextLabel == 'Finir' && this.nbPatientsFilled == this.nbPatients) || (this.currentPatient == 1 && this.currentPosition < this.criteriaQuestionTotalNumber))	{
						return false;
					}
					return this.isFirstOrSecondStep && this.nbPatientsFilled >= 1;
				}
				return false;
			}
		},
		props: ["isFirstOrSecondStep"],
		methods: {
			previous()	{
				let previousSteps = {
					"CRITIC_STEP": "FIRST_STEP",
					"SECOND_STEP": "CRITIC_STEP",
					"SATISFACTION_SURVEY": "SECOND_STEP",
				};
				if (this.currentPosition == 1 && this.currentPatient != 1 && this.currentStep != 'CRITIC_STEP' && this.currentStep != 'SATISFACTION_SURVEY')	{
					return this.$store.dispatch("changePatient", {newPatient: this.currentPatient - 1, button: true});
				}
				if (this.currentPosition == 1)
					return this.$store.dispatch('previousStep', previousSteps[this.currentStep]);
				this.$store.dispatch("changePosition", this.currentPosition - 1);
			},
			next()	{
				this.$store.commit('NEXT_BUTTON_DISABLED_UPDATED', true);
				let satisfactionSurveyEnabled = this.$store.state.user.satisfactionSurveyEnabled;
				let nextSteps = {
					"FIRST_STEP": "CRITIC_STEP",
					"CRITIC_STEP": "SECOND_STEP",
					"SECOND_STEP":  satisfactionSurveyEnabled ? "SATISFACTION_SURVEY" : "END"
				};

				if (satisfactionSurveyEnabled)	{
					nextSteps["SATISFACTION_SURVEY"] = "END";
				}
				if (this.currentPosition == this.criteriaQuestionTotalNumber && this.currentPatient != this.nbPatients && this.currentStep != 'CRITIC_STEP' && this.currentStep != 'SATISFACTION_SURVEY')	{
					return this.$store.dispatch("changePatient", {newPatient: this.currentPatient + 1, button: true});
				}
				if (this.currentPosition == this.criteriaQuestionTotalNumber)	{
					this.$store.dispatch("finishStep", nextSteps[this.currentStep]);
					if (this.opignoMode == 1 && this.currentStep == 'CRITIC_STEP')	{
						this.$router.push({name: 'FirstRoundEnd'});
					}
					else if (this.opignoMode == 2 && this.currentStep == (satisfactionSurveyEnabled ? "SATISFACTION_SURVEY" : "SECOND_STEP"))	{
						this.$router.push({name: 'SecondRoundEnd'});
					}
					return;
				}
				this.$store.dispatch("changePosition", this.currentPosition + 1);
			},
			finishStep()	{
				let satisfactionSurveyEnabled = this.$store.state.user.satisfactionSurveyEnabled;
				let nextSteps = {
					"FIRST_STEP": "CRITIC_STEP",
					"CRITIC_STEP": "SECOND_STEP",
					"SECOND_STEP":  satisfactionSurveyEnabled ? "SATISFACTION_SURVEY" : "END"
				};

				if (satisfactionSurveyEnabled)	{
					nextSteps["SATISFACTION_SURVEY"] = "END";
				}

				this.toggleUntoggle();
				let newStep = nextSteps[this.currentStep];
				if (this.$store.state.user.selectedAnswer != -1)	{
					return this.$store.dispatch("finishStep", newStep);
				}
				this.$store.dispatch('endStep', {
	                nextPosition: 1,
	                nextStep: newStep,
	                nextPatient: newStep == "FIRST_STEP" || newStep == "SECOND_STEP" ? 1 : 0
			    });
			},
			toggleUntoggle()	{
				this.showModal = !this.showModal;
			}
		},
		data: function()	{
			return {
				showModal: false,
				cancelTextModal: "Annuler",
				okTextModal: "Confirmer"
			};
		}
	}
</script>

</style>
